"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitPropsUsingArray = exports.inputPropsArray = exports.htmlInputPropsArray = exports.htmlInputEvents = exports.htmlInputProps = void 0;
exports.htmlInputProps = [
    // React
    'selected',
    'defaultValue',
    'defaultChecked',
    // HTML attributes
    'accept',
    'autoCapitalize',
    'autoComplete',
    'autoCorrect',
    'autoFocus',
    'checked',
    'disabled',
    'form',
    'id',
    'lang',
    'list',
    'max',
    'maxLength',
    'min',
    'minLength',
    'multiple',
    'name',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'step',
    'title',
    'type',
    'value',
];
exports.htmlInputEvents = [
    // Keyboard
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    // Focus
    'onFocus',
    'onBlur',
    // Form
    'onChange',
    'onInput',
    // Mouse
    'onClick',
    'onContextMenu',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    // Selection
    'onSelect',
    // Touch
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
];
exports.htmlInputPropsArray = __spreadArray(__spreadArray([], exports.htmlInputProps), exports.htmlInputEvents);
exports.inputPropsArray = [
    'el',
    'action',
    'actionPosition',
    'children',
    'className',
    'disabled',
    'error',
    'fluid',
    'focus',
    'icon',
    'iconPosition',
    'input',
    'inverted',
    'large',
    'loading',
    'onChange',
    'size',
    'shortLabel',
    'shortLabelPosition',
    'small',
    'tabIndex',
    'transparent',
    'type',
    'xsmall',
];
// Returns an array of objects consisting of [props found in targetKeysArray, rest]
var splitPropsUsingArray = function (props, targetKeysArray) {
    var rest = __assign({}, props);
    var targetProps = targetKeysArray.reduce(function (result, propName) {
        if (rest.hasOwnProperty(propName)) {
            result[propName] = rest[propName];
            delete rest[propName];
        }
        return result;
    }, {});
    return [targetProps, rest];
};
exports.splitPropsUsingArray = splitPropsUsingArray;
//# sourceMappingURL=inputProps.js.map